<script lang="ts">
  import IconButton from '@smui/icon-button';
  import TopAppBar, { Row, Section, Title } from '@smui/top-app-bar';
  import { getContext } from 'svelte';

  const { toggleDrawer } = getContext('drawer');
</script>

<div class="spacer" />
<TopAppBar variant="fixed" class="mdc-elevation--z3 nav-bar" style="top: 0">
  <Row>
    <Section>
      <IconButton class="material-icons" style="margin:0" on:click={() => toggleDrawer()}
        >menu</IconButton>
      <Title>Every Single Street | Portland, ME</Title>
    </Section>
  </Row>
</TopAppBar>

<style lang="scss">
  @use 'src/styles/variables' as vars;

  .spacer {
    height: vars.$nav-height;
  }
</style>
